import { render } from "./ShowOrdersComponent.vue?vue&type=template&id=703311b8"
import script from "./ShowOrdersComponent.vue?vue&type=script&lang=js"
export * from "./ShowOrdersComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__